/**
 * Внедрение рандомного query в путь файла, чтобы игнорировать кэш
 */
export const makeFileNotCacheable = (filePath: string) => `${filePath}?${(Date.now() / 60000) | 0}`;
